export const roundNumber = (num: number, precision = 1): number => {
    const factor = Math.pow(10, precision);
    return Math.round(num * factor) / factor;
};